// src/utils/date.ts
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale('ko');

export function formatKoreanDate(dateString: string) {
  return dayjs(dateString).tz('Asia/Seoul').format('YYYY. MM. DD');
}

/**
 * 서버에서 오는 날짜 문자열을 한국 시간(Asia/Seoul)으로 해석해 Date로 반환.
 */
export function parseDateInKST(dateString: string): Date {
  return dayjs.tz(dateString, 'Asia/Seoul').toDate();
}

// 요금제 변경 시작일(서버/KST 기준 해석)
export const UNLIMITED_CHANGE_PRICE_EFFECTIVE_DATE = parseDateInKST(
  '2026-03-16 00:00:00',
);

/** 한달 무제한 할인 적용 기간 (이 기간에만 discountAmount, discountBanner 적용) */
export const MONTH_UNLIMITED_DISCOUNT_DATE_START = parseDateInKST(
  '2025-11-01 00:00:00',
);
export const MONTH_UNLIMITED_DISCOUNT_DATE_END = parseDateInKST(
  '2026-03-11 23:59:59',
);

export function isDateOver(now: Date, date: Date) {
  return now >= date;
}

export function isDateBetween(now: Date, startDate: Date, endDate: Date) {
  return now >= startDate && now <= endDate;
}
